export class LocalStorageFacade {

    /**
     * 写入会话存储
     * @param {string} key
     * @param {Object} value
     */
    static set(key, value) {
        localStorage.setItem(key, JSON.stringify(value));
        return this;
    }

    /**
     * 读取会话存储
     * @param {string} key
     * @return {Object}
     */
    static get(key) {
        try {
            let info = localStorage.getItem(key);
            if (info) return JSON.parse(info);
            return {};
        } catch (e) {
            return {};
        }
    }

}
